import styled from 'styled-components';

export const Container = styled.div`
  > h2 {
    margin-bottom: 20px;
  }

  .radar-area {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const AddForm = styled.form`
  margin-top: 20px;

  .form-group {
    strong {
      font-size: 18px;
    }
  }

  .input-group {
    display: flex;
    flex-direction: column;
    font-size: 15px;
    margin-bottom: 10px;
    width: 100%;
  }

  .w-20 {
    width: fit-content;
    input {
      width: 80px;
    }
  }

  .inputs-group {
    display: flex;
    gap: 16px;
  }

  .button-group {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;

    button {
      display: flex;
      align-items: center;
      padding: 10px 20px;
      font-weight: bold;
    }
  }
`;
